// import firstsem from "../images/icons/firstsem.svg";
import pdf from "../pdf/dummy.pdf";

import ppa from "../images/icons/ppa.svg";
import cfoa from "../images/icons/cfoa.svg";
import bc from "../images/icons/bc.svg";
import pom from "../images/icons/pom.svg";
import ob from "../images/icons/ob.svg";
import deco from "../images/icons/deco.svg";
import fam from "../images/icons/fam.svg";
import cpp from "../images/icons/cpp.svg";
import dsa from "../images/icons/dsa.svg";
import stat from "../images/icons/statistics.svg";
import cgma from "../images/icons/cgma.svg";
import os from "../images/icons/os.svg";
import se from "../images/icons/se.svg";
import ot from "../images/icons/ot.svg";
import dbms from "../images/icons/dbms.svg";
import java from "../images/icons/java.svg";
import cn from "../images/icons/cn.svg";
import cns from "../images/icons/cns.svg";
import ecommerce from "../images/icons/ecommerce.svg";
import is from "../images/icons/is.svg";
import km from "../images/icons/km.svg";
import html from "../images/icons/html.svg";
import css from "../images/icons/css.svg";
import javascript from "../images/icons/javascript.svg";
import react from "../images/icons/react.svg";
import sql from "../images/icons/sql.svg";

export const data = [
  {
    id: 1,
    img: ppa,
    heading: "First",
    slug: "first",
    overview:
      "In BCA's 1st semester, study Programming Principles, Computer Fundamentals, Business Communication, and Principles of Management for a strong academic foundation.",
    subjects: [
      {
        name: "Programming Principle & Algorithm (PPA)",
        id: 101,
        code: "BCA-101",
        img: ppa,
        units: [
          { name: "Unit 1", link: pdf, slug: "first_unit" },
          { name: "Unit 2", link: pdf, slug: "second_unit" },
          { name: "Unit 3", link: pdf, slug: "third_unit" },
          { name: "Unit 4", link: pdf, slug: "fourth_unit" },
          { name: "Unit 5", link: pdf, slug: "fifth_unit" },
          { name: "Unit 6", link: pdf, slug: "sixth_unit" },
        ],
      },
      {
        name: "Computer Fundamental & Office Automation (CFOA)",
        id: 102,
        code: "BCA-102",
        img: cfoa,
        units: [
          { name: "Unit 1", link: pdf },
          { name: "Unit 2", link: pdf },
          { name: "Unit 3", link: pdf },
          { name: "Unit 4", link: pdf },
          { name: "Unit 5", link: pdf },
          { name: "Unit 6", link: pdf },
        ],
      },
      {
        name: "Business Communication (BC)",
        id: 103,
        code: "BCA-103",
        img: bc,
        units: [
          { name: "Unit 1", link: pdf },
          { name: "Unit 2", link: pdf },
          { name: "Unit 3", link: pdf },
          { name: "Unit 4", link: pdf },
          { name: "Unit 5", link: pdf },
          { name: "Unit 6", link: pdf },
        ],
      },
      {
        name: "Principle of Management (POM)",
        id: 104,
        code: "BCA-104",
        img: pom,
        units: [
          { name: "Unit 1", link: "https://example.com/unit1-doc" },
          { name: "Unit 2", link: "https://example.com/unit2-doc" },
          { name: "Unit 3", link: "https://example.com/unit2-doc" },
          { name: "Unit 4", link: "https://example.com/unit2-doc" },
          { name: "Unit 5", link: "https://example.com/unit2-doc" },
          { name: "Unit 6", link: "https://example.com/unit2-doc" },
        ],
      },
    ],
  },
  {
    id: 2,
    img: deco,
    heading: "Second",
    slug: "second",
    overview:
      "Learn C Programming, Organizational Behavior, Digital Electronics, and Financial Accounting for advanced computational skills and business understanding.",
    subjects: [
      {
        name: "C Programming",
        id: 202,
        code: "BCA-202",
        img: ppa,
        units: [
          { name: "Unit 1", link: "https://example.com/unit1-doc" },
          { name: "Unit 2", link: "https://example.com/unit2-doc" },
          { name: "Unit 3", link: "https://example.com/unit2-doc" },
          { name: "Unit 4", link: "https://example.com/unit2-doc" },
          { name: "Unit 5", link: "https://example.com/unit2-doc" },
          { name: "Unit 6", link: "https://example.com/unit2-doc" },
        ],
      },
      {
        name: "OB",
        id: 203,
        code: "BCA-203",
        img: ob,
        units: [
          { name: "Unit 1", link: "https://example.com/unit1-doc" },
          { name: "Unit 2", link: "https://example.com/unit2-doc" },
          { name: "Unit 3", link: "https://example.com/unit2-doc" },
          { name: "Unit 4", link: "https://example.com/unit2-doc" },
          { name: "Unit 5", link: "https://example.com/unit2-doc" },
          { name: "Unit 6", link: "https://example.com/unit2-doc" },
        ],
      },
      {
        name: "DECO",
        id: 204,
        code: "BCA-204",
        img: deco,
        units: [
          { name: "Unit 1", link: "https://example.com/unit1-doc" },
          { name: "Unit 2", link: "https://example.com/unit2-doc" },
          { name: "Unit 3", link: "https://example.com/unit2-doc" },
          { name: "Unit 4", link: "https://example.com/unit2-doc" },
          { name: "Unit 5", link: "https://example.com/unit2-doc" },
          { name: "Unit 6", link: "https://example.com/unit2-doc" },
        ],
      },
      {
        name: "FAM",
        id: 205,
        code: "BCA-205",
        img: fam,
        units: [
          { name: "Unit 1", link: "https://example.com/unit1-doc" },
          { name: "Unit 2", link: "https://example.com/unit2-doc" },
          { name: "Unit 3", link: "https://example.com/unit2-doc" },
          { name: "Unit 4", link: "https://example.com/unit2-doc" },
          { name: "Unit 5", link: "https://example.com/unit2-doc" },
          { name: "Unit 6", link: "https://example.com/unit2-doc" },
        ],
      },
    ],
  },
  {
    id: 3,
    img: cpp,
    heading: "Third",
    slug: "third",
    overview:
      "Study Object-Oriented Programming, Data Structures, Computer Architecture, Business Economics, and Elements of Statistics for technical and analytical expertise.",
    subjects: [
      {
        name: "Object Oriented Programming Using C++ (C++)",
        id: 301,
        code: "BCA-301",
        img: cpp,
        units: [
          { name: "Unit 1", link: "https://example.com/unit1-doc" },
          { name: "Unit 2", link: "https://example.com/unit2-doc" },
          { name: "Unit 3", link: "https://example.com/unit2-doc" },
          { name: "Unit 4", link: "https://example.com/unit2-doc" },
          { name: "Unit 5", link: "https://example.com/unit2-doc" },
          { name: "Unit 6", link: "https://example.com/unit2-doc" },
        ],
      },
      {
        name: "Data Structure Using C & C++ (DSC)",
        id: 302,
        code: "BCA-302",
        img: dsa,
        units: [
          { name: "Unit 1", link: "https://example.com/unit1-doc" },
          { name: "Unit 2", link: "https://example.com/unit2-doc" },
          { name: "Unit 3", link: "https://example.com/unit2-doc" },
          { name: "Unit 4", link: "https://example.com/unit2-doc" },
          { name: "Unit 5", link: "https://example.com/unit2-doc" },
          { name: "Unit 6", link: "https://example.com/unit2-doc" },
        ],
      },
      {
        name: "Computer Architecture & Assembly language (CALL)",
        id: 303,
        code: "BCA-303",
        img: deco,
        units: [
          { name: "Unit 1", link: "https://example.com/unit1-doc" },
          { name: "Unit 2", link: "https://example.com/unit2-doc" },
          { name: "Unit 3", link: "https://example.com/unit2-doc" },
          { name: "Unit 4", link: "https://example.com/unit2-doc" },
          { name: "Unit 5", link: "https://example.com/unit2-doc" },
          { name: "Unit 6", link: "https://example.com/unit2-doc" },
        ],
      },
      {
        name: "Business Economics (BE)",
        id: 304,
        code: "BCA-304",
        img: pom,
        units: [
          { name: "Unit 1", link: "https://example.com/unit1-doc" },
          { name: "Unit 2", link: "https://example.com/unit2-doc" },
          { name: "Unit 3", link: "https://example.com/unit2-doc" },
          { name: "Unit 4", link: "https://example.com/unit2-doc" },
          { name: "Unit 5", link: "https://example.com/unit2-doc" },
          { name: "Unit 6", link: "https://example.com/unit2-doc" },
        ],
      },
      {
        name: "Elements of Statistics",
        id: 305,
        code: "BCA-305",
        img: stat,
        units: [
          { name: "Unit 1", link: "https://example.com/unit1-doc" },
          { name: "Unit 2", link: "https://example.com/unit2-doc" },
          { name: "Unit 3", link: "https://example.com/unit2-doc" },
          { name: "Unit 4", link: "https://example.com/unit2-doc" },
          { name: "Unit 5", link: "https://example.com/unit2-doc" },
          { name: "Unit 6", link: "https://example.com/unit2-doc" },
        ],
      },
    ],
  },
  {
    id: 4,
    img: os,
    heading: "Fourth",
    slug: "fourth",
    overview:
      "Focus on Computer Graphics, Operating Systems, Software Engineering, and Optimization Techniques for improved technical prowess and problem-solving.",
    subjects: [
      {
        name: "Computer Graphics & Multimedia Application (CGMA)",
        id: 401,
        code: "BCA-401",
        img: cgma,
        units: [
          { name: "Unit 1", link: "https://example.com/unit1-doc" },
          { name: "Unit 2", link: "https://example.com/unit2-doc" },
          { name: "Unit 3", link: "https://example.com/unit2-doc" },
          { name: "Unit 4", link: "https://example.com/unit2-doc" },
          { name: "Unit 5", link: "https://example.com/unit2-doc" },
          { name: "Unit 6", link: "https://example.com/unit2-doc" },
        ],
      },
      {
        name: "Operating System (OS)",
        id: 402,
        code: "BCA-402",
        img: os,
        units: [
          { name: "Unit 1", link: "https://example.com/unit1-doc" },
          { name: "Unit 2", link: "https://example.com/unit2-doc" },
          { name: "Unit 3", link: "https://example.com/unit2-doc" },
          { name: "Unit 4", link: "https://example.com/unit2-doc" },
          { name: "Unit 5", link: "https://example.com/unit2-doc" },
          { name: "Unit 6", link: "https://example.com/unit2-doc" },
        ],
      },
      {
        name: "Software Engineering (SE)",
        id: 403,
        code: "BCA-403",
        img: se,
        units: [
          { name: "Unit 1", link: "https://example.com/unit1-doc" },
          { name: "Unit 2", link: "https://example.com/unit2-doc" },
          { name: "Unit 3", link: "https://example.com/unit2-doc" },
          { name: "Unit 4", link: "https://example.com/unit2-doc" },
          { name: "Unit 5", link: "https://example.com/unit2-doc" },
          { name: "Unit 6", link: "https://example.com/unit2-doc" },
        ],
      },
      {
        name: "Optimization Techniques (OT)",
        id: 404,
        code: "BCA-404",
        img: ot,
        units: [
          { name: "Unit 1", link: "https://example.com/unit1-doc" },
          { name: "Unit 2", link: "https://example.com/unit2-doc" },
          { name: "Unit 3", link: "https://example.com/unit2-doc" },
          { name: "Unit 4", link: "https://example.com/unit2-doc" },
          { name: "Unit 5", link: "https://example.com/unit2-doc" },
          { name: "Unit 6", link: "https://example.com/unit2-doc" },
        ],
      },
    ],
  },
  {
    id: 5,
    img: dbms,
    heading: "Fifth",
    slug: "fifth",
    overview:
      "Explore Database Management, Java Programming, Dynamic Webpage Design, Computer Networks, and Numerical Methods for specialized practical skills.",
    subjects: [
      {
        name: "Introduction to DBMS (DBMS)",
        id: 501,
        code: "BCA-501",
        img: dbms,
        units: [
          { name: "Unit 1", link: "https://example.com/unit1-doc" },
          { name: "Unit 2", link: "https://example.com/unit2-doc" },
          { name: "Unit 3", link: "https://example.com/unit2-doc" },
          { name: "Unit 4", link: "https://example.com/unit2-doc" },
          { name: "Unit 5", link: "https://example.com/unit2-doc" },
          { name: "Unit 6", link: "https://example.com/unit2-doc" },
        ],
      },
      {
        name: "Java Programming and Dynamic Webpage Design (JAVA)",
        id: 502,
        code: "BCA-502",
        img: java,
        units: [
          { name: "Unit 1", link: "https://example.com/unit1-doc" },
          { name: "Unit 2", link: "https://example.com/unit2-doc" },
          { name: "Unit 3", link: "https://example.com/unit2-doc" },
          { name: "Unit 4", link: "https://example.com/unit2-doc" },
          { name: "Unit 5", link: "https://example.com/unit2-doc" },
          { name: "Unit 6", link: "https://example.com/unit2-doc" },
        ],
      },
      {
        name: "Computer Network (CN)",
        id: 503,
        code: "BCA-503",
        img: cn,
        units: [
          { name: "Unit 1", link: "https://example.com/unit1-doc" },
          { name: "Unit 2", link: "https://example.com/unit2-doc" },
          { name: "Unit 3", link: "https://example.com/unit2-doc" },
          { name: "Unit 4", link: "https://example.com/unit2-doc" },
          { name: "Unit 5", link: "https://example.com/unit2-doc" },
          { name: "Unit 6", link: "https://example.com/unit2-doc" },
        ],
      },
      {
        name: "Numerical Methods (NM)",
        id: 504,
        code: "BCA-504",
        img: ot,
        units: [
          { name: "Unit 1", link: "https://example.com/unit1-doc" },
          { name: "Unit 2", link: "https://example.com/unit2-doc" },
          { name: "Unit 3", link: "https://example.com/unit2-doc" },
          { name: "Unit 4", link: "https://example.com/unit2-doc" },
          { name: "Unit 5", link: "https://example.com/unit2-doc" },
          { name: "Unit 6", link: "https://example.com/unit2-doc" },
        ],
      },
    ],
  },
  {
    id: 6,
    img: km,
    heading: "Sixth",
    slug: "sixth",
    overview:
      "Engage in Computer Network Security, Information Systems Analysis, E-Commerce, and Knowledge Management for real-world application of skills.",
    subjects: [
      {
        name: "Computer Network Security (CNS)",
        id: 601,
        code: "BCA-601",
        img: cns,
        units: [
          { name: "Unit 1", link: "https://example.com/unit1-doc" },
          { name: "Unit 2", link: "https://example.com/unit2-doc" },
          { name: "Unit 3", link: "https://example.com/unit2-doc" },
          { name: "Unit 4", link: "https://example.com/unit2-doc" },
          { name: "Unit 5", link: "https://example.com/unit2-doc" },
          { name: "Unit 6", link: "https://example.com/unit2-doc" },
        ],
      },
      {
        name: "Information System: Analysis Design & Implementation (IN)",
        id: 602,
        code: "BCA-602",
        img: is,
        units: [
          { name: "Unit 1", link: "https://example.com/unit1-doc" },
          { name: "Unit 2", link: "https://example.com/unit2-doc" },
          { name: "Unit 3", link: "https://example.com/unit2-doc" },
          { name: "Unit 4", link: "https://example.com/unit2-doc" },
          { name: "Unit 5", link: "https://example.com/unit2-doc" },
          { name: "Unit 6", link: "https://example.com/unit2-doc" },
        ],
      },
      {
        name: "E-Commerce",
        id: 603,
        code: "BCA-603",
        img: ecommerce,
        units: [
          { name: "Unit 1", link: "https://example.com/unit1-doc" },
          { name: "Unit 2", link: "https://example.com/unit2-doc" },
          { name: "Unit 3", link: "https://example.com/unit2-doc" },
          { name: "Unit 4", link: "https://example.com/unit2-doc" },
          { name: "Unit 5", link: "https://example.com/unit2-doc" },
          { name: "Unit 6", link: "https://example.com/unit2-doc" },
        ],
      },
      {
        name: "Knowledge Management (KM)",
        id: 604,
        code: "BCA-604",
        img: km,
        units: [
          { name: "Unit 1", link: "https://example.com/unit1-doc" },
          { name: "Unit 2", link: "https://example.com/unit2-doc" },
          { name: "Unit 3", link: "https://example.com/unit2-doc" },
          { name: "Unit 4", link: "https://example.com/unit2-doc" },
          { name: "Unit 5", link: "https://example.com/unit2-doc" },
          { name: "Unit 6", link: "https://example.com/unit2-doc" },
        ],
      },
    ],
  },
];

export const programNotes = {
  title: "Programming Languages Notes",
  languages: [
    {
      id: 1,
      img: ppa,
      heading: "C++ Notes",
      slug: "cpp",
      link: pdf,
    },
    {
      id: 2,
      img: dsa,
      heading: "DSA",
      slug: "dsa",
      link: pdf,
    },
    {
      id: 3,
      img: html,
      heading: "HTML",
      slug: "html",
      link: pdf,
    },
    {
      id: 4,
      img: css,
      heading: "CSS",
      slug: "css",
      link: pdf,
    },
    {
      id: 5,
      img: javascript,
      heading: "Javascript",
      slug: "javascript",
      link: pdf,
    },
    {
      id: 6,
      img: react,
      heading: "React",
      slug: "react",
      link: pdf,
    },
    {
      id: 7,
      img: sql,
      heading: "SQL",
      slug: "sql",
      link: pdf,
    },
    {
      id: 7,
      img: java,
      heading: "Java",
      slug: "java",
      link: pdf,
    },
  ],
};
